import SaveToggle from "./SaveToggle";
import TriToggle from "./TriToggle";
import AvailabilityToggle from "./AvailabilityToggle";
import { DuoToggle } from "./DuoToggle";

// Not including DuoToggle in the default exports b/c we decided we're using named exports

export { SaveToggle, TriToggle, AvailabilityToggle, DuoToggle };
export default { SaveToggle, TriToggle, AvailabilityToggle };
